import React from 'react';

import { useHistory } from 'react-router-dom';
import Box from '@material-ui/core/Box';
import Button from '@material-ui/core/Button';
import Container from '@material-ui/core/Container';
import Grid from '@material-ui/core/Grid';
import Link from '@material-ui/core/Link';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { PAGE_ROUTE, TEST_USER } from '../../constants';
import API from '../../services/api';
import Copyright from '../../components/copyright';
import CustomAlert from '../custom/alert';
import { getValue } from '../helpers';

import useStyles from './styles';

const logo = process.env.PUBLIC_URL + '/assets/logos/logo.svg';

export const useInput = (initialValue) => {
  const [value, setValue] = React.useState(initialValue);
  return {
    value,
    setValue,
    bind: {
      value,
      onChange: (event) => {
        setValue(event.target.value);
      },
    },
    reset: () => setValue(''),
  };
};

export default function SignIn() {
  const history = useHistory();
  const classes = useStyles();
  const initialState = {
    email: TEST_USER.EMAIL,
    password: TEST_USER.PASSWORD,
  };

  const [alert, setAlert] = React.useState({ open: false, message: '' });
  const [validate, setValidate] = React.useState({});
  const [state, setState] = React.useState(initialState);

  //const initialState = {
  //  username: '',        // Store `username` when user enters their username
  //  password: '',        // Store `password` when user enters their password
  //  errors: {},          // Store error data from the backend here
  //  isAuthorized: false, // If auth is successful, set this to `true`
  //  isLoading: false,    // Set this to `true` if You want to show spinner
  //};

  // const { value: email,    bind:bindEmail,    reset:resetEmail } = useInput(TEST_USER.EMAIL);
  // const { value: password, bind:bindPassword, reset:resetPassword } = useInput(TEST_USER.PASSWORD);

  function handleSubmit(event) {
    event.preventDefault();

    if (!state.email) {
      setValidate({ ...validate, email: 'Por favor, insira seu email' });
      return;
    }

    if (!state.password) {
      setValidate({ ...validate, password: 'Por favor, insira sua senha' });
      return;
    }

    //const {username, password} = this.state;
    //const payload = {username, password};
    //console.log(payload);
    //const onSuccess = ({data}) => {
    //  // Set JSON Web Token on success
    //  setClientToken(data.token);
    //  this.setState({isLoading: false, isAuthorized: true});
    //};
    //const onFailure = error => {
    //  console.log(error && error.response);
    //  this.setState({errors: error.response.data, isLoading: false});
    //};
    //this.setState({isLoading: true}); // Show spinner when call is made
    //APIKit.post('/api-token-auth/', payload)
    //  .then(onSuccess)
    //  .catch(onFailure);

    API.signIn(state)
      .then((response) => {
        setState(initialState);

        const profile_id = getValue(response.data, 'profile_id');
        if (profile_id === 2) {
          history.push(PAGE_ROUTE.OPERATIONS);
        } else {
          history.push(PAGE_ROUTE.DASHBOARD);
        }
      })
      .catch((error) => {
        setAlert({ open: true, message: error.message });
      });
  }

  return (
    <Container component="main" maxWidth="xs">
      <CustomAlert open={alert.open} onClose={() => setAlert({ ...alert, open: false })}>
        {alert.message}
      </CustomAlert>
      <div className={classes.paper}>
        <Grid container direction="row" alignItems="center" justifyContent="center">
          <img className={classes.logo} src={logo} alt={' '} />
          <Typography component="h1" variant="h4">
            Banco Mais
          </Typography>
        </Grid>
        <form className={classes.form} noValidate>
          <TextField
            autoComplete="email"
            autoFocus
            fullWidth={true}
            id="email"
            label="Login"
            margin="normal"
            name="email"
            value={state.email || ''}
            required={true}
            helperText={validate.email ? validate.email : ''}
            error={validate.email ? true : false}
            onFocus={() => setValidate({ ...validate, email: null })}
            variant="outlined"
            onChange={(event) => setState({ ...state, email: event.target.value })}
            //{...bindEmail}
          />
          <TextField
            autoComplete="current-password"
            fullWidth={true}
            id="password"
            label="Senha"
            margin="normal"
            name="password"
            value={state.password || ''}
            required={true}
            helperText={validate.password ? validate.password : ''}
            error={validate.password ? true : false}
            onFocus={() => setValidate({ ...validate, password: null })}
            type="password"
            variant="outlined"
            onChange={(event) => setState({ ...state, password: event.target.value })}
            //{...bindPassword}
          />
          <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit} onClick={handleSubmit}>
            ACESSAR
          </Button>

          <Grid container>
            <Grid item>
              <Link href="#" variant="body2">
                Esqueceu seu login?
              </Link>
            </Grid>
          </Grid>
        </form>
      </div>
      <Box mt={8}>
        <Copyright />
      </Box>
    </Container>
  );
}
